/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * API V5
 * OpenAPI spec version: v5
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  AiMessageDemoGenerateReplyRequest,
  AiMessageErrorResponse,
  AiMessageGenerateReplyRequest,
  AiMessageGenerateReplyResponse,
  AiMessageGenerateRequest,
  AiMessageGenerateResponse
} from '.././schemas'
import postApiV5AiMessagesGenerateMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5AiMessagesGenerateErrorType } from '../../configOrvalAPIV5';
import postApiV5AiMessagesGenerateReplyMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5AiMessagesGenerateReplyErrorType } from '../../configOrvalAPIV5';
import postApiV5AiMessagesDemoGenerateReplyMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5AiMessagesDemoGenerateReplyErrorType } from '../../configOrvalAPIV5';



/**
 * @summary Generate AI content for a message based on user prompt
 */
export const postApiV5AiMessagesGenerate = (
    aiMessageGenerateRequest: AiMessageGenerateRequest,
 ) => {
      
      
      return postApiV5AiMessagesGenerateMutator<AiMessageGenerateResponse>(
      {url: `/api/v5/ai_messages/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiMessageGenerateRequest
    },
      );
    }
  


export const getPostApiV5AiMessagesGenerateMutationOptions = <TError = PostApiV5AiMessagesGenerateErrorType<AiMessageErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesGenerate>>, TError,{data: AiMessageGenerateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesGenerate>>, TError,{data: AiMessageGenerateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5AiMessagesGenerate>>, {data: AiMessageGenerateRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiV5AiMessagesGenerate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5AiMessagesGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5AiMessagesGenerate>>>
    export type PostApiV5AiMessagesGenerateMutationBody = AiMessageGenerateRequest
    export type PostApiV5AiMessagesGenerateMutationError = PostApiV5AiMessagesGenerateErrorType<AiMessageErrorResponse>

    /**
 * @summary Generate AI content for a message based on user prompt
 */
export const usePostApiV5AiMessagesGenerate = <TError = PostApiV5AiMessagesGenerateErrorType<AiMessageErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesGenerate>>, TError,{data: AiMessageGenerateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5AiMessagesGenerate>>,
        TError,
        {data: AiMessageGenerateRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV5AiMessagesGenerateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Generate AI reply based on thread conversation history
 */
export const postApiV5AiMessagesGenerateReply = (
    aiMessageGenerateReplyRequest: AiMessageGenerateReplyRequest,
 ) => {
      
      
      return postApiV5AiMessagesGenerateReplyMutator<AiMessageGenerateReplyResponse>(
      {url: `/api/v5/ai_messages/generate_reply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiMessageGenerateReplyRequest
    },
      );
    }
  


export const getPostApiV5AiMessagesGenerateReplyMutationOptions = <TError = PostApiV5AiMessagesGenerateReplyErrorType<AiMessageErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesGenerateReply>>, TError,{data: AiMessageGenerateReplyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesGenerateReply>>, TError,{data: AiMessageGenerateReplyRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5AiMessagesGenerateReply>>, {data: AiMessageGenerateReplyRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiV5AiMessagesGenerateReply(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5AiMessagesGenerateReplyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5AiMessagesGenerateReply>>>
    export type PostApiV5AiMessagesGenerateReplyMutationBody = AiMessageGenerateReplyRequest
    export type PostApiV5AiMessagesGenerateReplyMutationError = PostApiV5AiMessagesGenerateReplyErrorType<AiMessageErrorResponse>

    /**
 * @summary Generate AI reply based on thread conversation history
 */
export const usePostApiV5AiMessagesGenerateReply = <TError = PostApiV5AiMessagesGenerateReplyErrorType<AiMessageErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesGenerateReply>>, TError,{data: AiMessageGenerateReplyRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5AiMessagesGenerateReply>>,
        TError,
        {data: AiMessageGenerateReplyRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV5AiMessagesGenerateReplyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Used during onboarding to showcase AI-powered messaging capabilities. Generates a professional AI reply based on a sample message and optional user draft reply.
 * @summary Generate AI reply for demo purposes without requiring existing message thread
 */
export const postApiV5AiMessagesDemoGenerateReply = (
    aiMessageDemoGenerateReplyRequest: AiMessageDemoGenerateReplyRequest,
 ) => {
      
      
      return postApiV5AiMessagesDemoGenerateReplyMutator<AiMessageGenerateReplyResponse>(
      {url: `/api/v5/ai_messages/demo_generate_reply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiMessageDemoGenerateReplyRequest
    },
      );
    }
  


export const getPostApiV5AiMessagesDemoGenerateReplyMutationOptions = <TError = PostApiV5AiMessagesDemoGenerateReplyErrorType<AiMessageErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesDemoGenerateReply>>, TError,{data: AiMessageDemoGenerateReplyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesDemoGenerateReply>>, TError,{data: AiMessageDemoGenerateReplyRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5AiMessagesDemoGenerateReply>>, {data: AiMessageDemoGenerateReplyRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiV5AiMessagesDemoGenerateReply(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5AiMessagesDemoGenerateReplyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5AiMessagesDemoGenerateReply>>>
    export type PostApiV5AiMessagesDemoGenerateReplyMutationBody = AiMessageDemoGenerateReplyRequest
    export type PostApiV5AiMessagesDemoGenerateReplyMutationError = PostApiV5AiMessagesDemoGenerateReplyErrorType<AiMessageErrorResponse>

    /**
 * @summary Generate AI reply for demo purposes without requiring existing message thread
 */
export const usePostApiV5AiMessagesDemoGenerateReply = <TError = PostApiV5AiMessagesDemoGenerateReplyErrorType<AiMessageErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5AiMessagesDemoGenerateReply>>, TError,{data: AiMessageDemoGenerateReplyRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5AiMessagesDemoGenerateReply>>,
        TError,
        {data: AiMessageDemoGenerateReplyRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV5AiMessagesDemoGenerateReplyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    